import Grid from "@mui/material/Grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import WarningMessage from "../../layouts/dashboards/warning";

const NoMerchantWarning = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <Grid container mt={10} justifyContent="center">
      <Grid item xs={12} md={6}>
        <WarningMessage
          text="No merchant account setup"
          detail="Please add a merchant account to view your dashboard"
          url="app/settings/add-account"
          actionText="Add Account"
        />
      </Grid>
    </Grid>
  </DashboardLayout>
);

export default NoMerchantWarning; 